import React from 'react';
import routes from 'sitewide-js/core_pre_webpack/routes';
import styled from 'astroturf/react';
import InfoIcon from 'js/design_system/icons/info.svg';
import { Banner } from 'js/design_system/Banner';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Body } from 'js/design_system/Body';

const ExploreButton = styled(ButtonLink)`
  height: auto;
  width: auto;
  margin: -8px 0 -8px auto;
  padding: 6px 20px;
  font-size: 14px;
  text-align: center;
`;

interface Props {
  displayName: string;
}

export const ExploreConversations = (props: Props) => {
  return (
    <Banner icon={<InfoIcon />}>
      <Body>
        {props.displayName} hasn't posted lately. See what your network is
        talking about.
      </Body>
      <ExploreButton inverse href={routes.home_url()}>
        Explore conversations
      </ExploreButton>
    </Banner>
  );
};
